
import {Vue, Component} from 'vue-property-decorator'
import ClientSearchField from '@/components/clients/ClientSearchField.vue'

@Component({metaInfo: {title:process.env.VUE_APP_NAME + " - Client dashboard"}, components : {ClientSearchField}})
export default class ClientsView extends Vue {
  

}
